<div>
    <a class="underlined-link" [routerLink]="['/business-partner']" [queryParams]="{ id: data.partnerId }">{{
        data[header.field] }}</a>
</div>